import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'
import { appGetState } from 'legacy/lut/store'
import { lookupGetStateOld } from 'legacy/lut/store'
import React, { useState } from 'react'

import { Checkbox } from 'core-components/library/checkbox'
import { Input } from 'core-components/library/inputs'
import { FilterArea, IPanelContentProps } from 'core-components/library/list/filterArea'
import { IDataProviderFilter, IFilter, Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'

interface IFilterAreaProps {
  source: Crud<IFormProfile>
  ignoredFields: string[]
}

const PanelContent = (props: IPanelContentProps<IFormProfile>) => {
  const filter = props.filter || { logic: Logic.AND, filters: [] }
  const orFilter: any = filter.filters.find(
    (el) => (el as IDataProviderFilter)['logic'] === Logic.OR
  )
  const value = orFilter ? orFilter.filters[0].value : ''

  const [inputValue, setInputValue] = useState(value)
  const [checkboxFilter, setCheckboxFilter] = useState(
    filter.filters.find((el: any) => el.field === 'Status' && !el.value)
  )

  React.useEffect(() => {
    const statusFilter = filter.filters.find((el: any) => el.field === 'Status' && !el.value)
    setCheckboxFilter(statusFilter)
  }, [filter])

  const fields = ['ContactID', 'FirstName', 'LastName']

  return (
    <div>
      <Input
        value={inputValue}
        onChange={(v) => {
          setInputValue(v)
          const newOrFilter = orFilter
            ? orFilter
            : {
                logic: Logic.OR,
                filters: [],
              }
          if (!orFilter) {
            filter.filters.push(newOrFilter)
          }
          newOrFilter.filters = fields.map((field) => ({
            field,
            operator: Operator.CONTAINS,
            value: v,
          }))
          props.onFilterChange(filter)
        }}
        label="Search..."
        autoFocus
      />
      <Checkbox
        margin={'md'}
        padding
        label={'Show inactive contacts'}
        checked={!!checkboxFilter}
        onChange={() => {
          if (!checkboxFilter) {
            const newCheckboxFilter = {
              field: 'Status',
              operator: Operator.EQUAL,
              value: undefined,
            }

            //@ts-ignore
            filter.filters.push(newCheckboxFilter)
            //@ts-ignore
            setCheckboxFilter(newCheckboxFilter)
          } else {
            filter.filters = filter.filters.filter(
              (el: any) => !(el.field === 'Status' && !el.value)
            )
            setCheckboxFilter(undefined)
          }
          props.onFilterChange(filter)
        }}
      />
    </div>
  )
}

export const ContactFilterArea = ({ source, ignoredFields }: IFilterAreaProps) => {
  return (
    <FilterArea<IFormProfile>
      source={source}
      PanelContent={PanelContent}
      ignoredDefaultFields={ignoredFields}
      onFilterRender={(filter: any) => {
        if (filter && (filter as IFilter).field === 'CountryOfBusiness') {
          const countries = lookupGetStateOld().references.countries
          const countryName = countries.find((el) => el.value === filter.value)
          return (
            <span>
              {filter.field} {filter.operator} {countryName ? countryName.name : filter.value}
            </span>
          )
        }
        if (
          filter &&
          (filter as IDataProviderFilter)['logic'] === Logic.OR &&
          filter.filters[0] &&
          filter.filters[0].field === 'CountryOfBusiness'
        ) {
          const countries = lookupGetStateOld().references.countries
          const countriesName = filter.filters.map((el: IFilter) =>
            countries.find((country) => country.value === el.value)
          )
          return (
            <span>
              {filter.filters[0].field}{' '}
              {filter.filters[0].operator === Operator.CONTAINS ? 'eq' : filter.filters[0].operator}{' '}
              {countriesName.map(
                (el: any, index: number) =>
                  el.name + (index !== countriesName.length - 1 ? ', ' : '')
              )}
            </span>
          )
        }
        if (filter && (filter as IDataProviderFilter)['logic'] === Logic.OR) {
          return (
            <span>
              Search by "
              {filter.filters.map((el: any, index: number) => {
                if (index !== filter.filters.length - 1) {
                  return el.value + ' | '
                }
                return el.value
              })}
              "
            </span>
          )
        }
        return undefined
      }}
    />
  )
}
